
    const html = "<div class=row> <div class=col-md-12> <offer-pricing profile=profileCtrl.profile authuser=app.user></offer-pricing> </div> </div> ";
    angular.module('ng').run(['$templateCache', function($templateCache){
      $templateCache.put('/modules/users/views/profile/profile-view-pricing.client.view.html', html);
    }]);
    module.exports = '/modules/users/views/profile/profile-view-pricing.client.view.html';
  